import { useState } from "react";
import cx from "classnames";
import styles from "./PaymentMethods.module.scss";
import VisaLogo from "../../resources/icons/payments/visa-logo.svg";
import VisaLogoLight from "../../resources/icons/payments/visa-logo-white.svg";
import DkLogo from "../../resources/icons/payments/dk-logo.svg";
import MastercardLogo from "../../resources/icons/payments/mastercard-logo-with-text.svg";
import MobilePayLogo from "../../resources/icons/payments/mobilepay-logo.svg";
import MobilePayLogoLight from "../../resources/icons/payments/mobilepay-logo-white.svg";
import { useTranslation } from "react-i18next";
import { IPaymentMethodModel, PaymentMethod } from "@nf/common";

interface PaymentMethodProps {
  method: IPaymentMethodModel;
  isActive?: boolean;
  setActive: (paymentMethodId: number) => void;
}

export const PaymentMethods = (props: PaymentMethodProps) => {
  const renderPaymentMethod = () => {
    if (props.method.MethodName === PaymentMethod.Card) {
      return <CreditCard {...props} />;
    }
    if (props.method.MethodName === PaymentMethod.MobilePay) {
      return <MobilePay {...props} />;
    }
    return null;
  };

  return renderPaymentMethod();
};

export const CreditCard = ({
  isActive,
  setActive,
  method,
}: PaymentMethodProps) => {
  const { t } = useTranslation("translations");
  const [isHover, toggleHover] = useState(false);

  return (
    <div
      onClick={() => setActive(method.Id)}
      className={cx(styles.PaymentMethod, { [styles.Selected]: isActive })}
      onMouseEnter={() => toggleHover(true)}
      onMouseLeave={() => toggleHover(false)}
    >
      <div className={styles.CreditCard}>
        <span> {t("web_payment_method_card")}</span>
        <div className={styles.Logos}>
          <DkLogo />
          {isHover || isActive ? <VisaLogo /> : <VisaLogoLight />}
          <MastercardLogo />
        </div>
      </div>
    </div>
  );
};

export const MobilePay = ({
  isActive,
  setActive,
  method,
}: PaymentMethodProps) => {
  const [isHover, toggleHover] = useState(false);
  return (
    <div
      onClick={() => setActive(method.Id)}
      className={cx(styles.PaymentMethod, { [styles.Selected]: isActive })}
      onMouseEnter={() => toggleHover(true)}
      onMouseLeave={() => toggleHover(false)}
    >
      <div className={styles.Mobilepay}>
        {isHover || isActive ? <MobilePayLogo /> : <MobilePayLogoLight />}
      </div>
    </div>
  );
};
